import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import VMTasksList from "./Tasks/VMTasksList";
import VMCheckList from "./Checklist/VMCheckList";
import StorageFactory from "../../Util/StorageFactory";
import { SESSION_VM_SELECTED_TAB } from "../../Util/VMConstants";
import { Paper } from "@mui/material";
import { VM_Colors } from "../../Styles/VMStyles";

const VMTaskChecklist = () => {
  
  const sessionFactory = new StorageFactory('session');
  const vm_selected_tab = sessionFactory.get(SESSION_VM_SELECTED_TAB);
  
  const [selectedTab, setSelectedTab] = useState(() => {
    return vm_selected_tab || "tasks";
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const storage = new StorageFactory("session");
    storage.add(SESSION_VM_SELECTED_TAB, selectedTab);
  }, [selectedTab]);

  const TabButton = ({ label, value }) => {
    const isSelected = selectedTab === value;

    return (
      <div
        onClick={() => setSelectedTab(value)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: isMobile ? "8px 12px" : "10px 20px",
          minWidth: isMobile ? "100px" : "150px",
          background: isSelected ? "#1E3A8A" : "#FFFFFF",
          border: isSelected ? "none" : "1px solid #1E3A8A",
          borderRadius: 6,
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
        }}
      >
        <span
          style={{
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: isMobile ? "16px" : "20px",
            color: isSelected ? "#FFFFFF" : "#1E3A8A",
            textAlign: "center",
          }}
        >
          {label}
        </span>
      </div>
    );
  };

  return (
    <Paper sx={{ padding: 2 , m:2, backgroundColor: VM_Colors.white2}}>
  
    <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "12px",
          marginBottom: 20,
          alignItems: isMobile ? "stretch" : "center",
        }}
      >
        <TabButton label="Tasks" value="tasks" />
        <TabButton label="Checklists" value="checklists" />
      </div>

      <div>
        {selectedTab === "tasks" && <VMTasksList />}
        {selectedTab === "checklists" && <VMCheckList />}
      </div>
    </Paper>
  );
};

export default VMTaskChecklist;
